import { render, staticRenderFns } from "./MerchantIdentity.vue?vue&type=template&id=475a4c7c&scoped=true"
import script from "./MerchantIdentity.vue?vue&type=script&lang=js"
export * from "./MerchantIdentity.vue?vue&type=script&lang=js"
import style0 from "./MerchantIdentity.vue?vue&type=style&index=0&id=475a4c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a4c7c",
  null
  
)

export default component.exports